module.exports = __webpack_public_path__ + "files/d0e1df5e220f2b7d2e2287f890c53a59.png";